<template>
  <BlankLayout>
    <v-layout align-center justify-center>
      <div>
        <div style="text-align: center">
          <img
            src="@/assets/logo.png"
            width="200"
            style="padding-bottom: 20px"
          />
        </div>
        <p style="text-align: center">
          <span>
            {{ $t('views.unauthorized.message') }}
          </span>
          <br /><br />
          <a href="https://fair-votes.com/live">FairVotes LIVE</a>
        </p>
      </div>
    </v-layout>
  </BlankLayout>
</template>

<script>
import BlankLayout from '@/components/layouts/Blank.vue'

export default {
  name: 'Unauthorized',

  components: {
    BlankLayout,
  },

  data() {
    return {
      title: this.$t('views.unauthorized.title'),
    }
  },

  watch: {
    '$i18n.locale': function () {
      this.title = this.$t('views.unauthorized.title')
      document.title = this.title
    },
  },

  created: function () {
    document.title = this.title
  },
}
</script>
